import { PropsWithChildren } from "react";
import { colors } from "../../stitches.config";
import { Container, IconWrapper, LeftContent } from "./__styles__/Toast";
import { ActionButton } from "./Buttons/ActionButton";
import { Icon, IconNames } from "./Icons/LucideIcons";
import { Body } from "./Typography";

type AppearanceTypes = "success" | "error" | "warning" | "info";

type ToastProps = {
  appearance?: AppearanceTypes;
  onDismiss: () => void;
};

const IconMap: Record<AppearanceTypes, IconNames> = {
  success: "check-circle",
  error: "x-circle",
  info: "info",
  warning: "alert-circle",
};

const ColorMap: Record<AppearanceTypes, keyof typeof colors> = {
  success: "contentSuccessInverted",
  error: "contentCriticalInverted",
  warning: "contentAttentionInverted",
  info: "contentInfoInverted",
};

export default ({
  children,
  appearance = "info",
  onDismiss,
}: PropsWithChildren<ToastProps>) => {
  return (
    <Container>
      <LeftContent>
        <IconWrapper>
          <Icon
            iconName={IconMap[appearance] as IconNames}
            color={ColorMap[appearance] as keyof typeof colors}
            size={16}
          />
        </IconWrapper>
        <Body color="contentPrimaryInverted" size={"default"} type={"emphasis"}>
          {children}
        </Body>
      </LeftContent>
      <IconWrapper>
        <ActionButton
          icon="x"
          onClick={() => onDismiss()}
          aria-label="Dismiss"
          data-testid="dismiss-toast"
          variant="inverted"
        />
      </IconWrapper>
    </Container>
  );
};
